import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "mx-0 row align-items-center" }
const _hoisted_3 = { class: "project-left align-items-baseline" }
const _hoisted_4 = { class: "ml-1 dropleft" }
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = {
  class: "dropdown-item",
  href: "#",
  "data-target": "#project-lock-modal",
  "data-toggle": "modal"
}
const _hoisted_7 = { class: "project-history-short-modal collapse" }
const _hoisted_8 = { class: "my-1" }
const _hoisted_9 = { class: "small project-history list-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_version_item = _resolveComponent("version-item")!

  return (_openBlock(), _createElementBlock("div", {
    id: `project-item-${_ctx.project.refid}`,
    class: "w-100 border-0"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "scaling-icon-r hidden fa fa-lock lock-status" }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.project.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[8] || (_cache[8] = _createElementVNode("button", {
          class: "btn btn-outline-secondary btn-icon btn-menu",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }, [
          _createElementVNode("i", { class: "fas fa-ellipsis-v" })
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("a", _hoisted_6, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fa fa-lock fa-fw" }, null, -1),
            _createTextVNode(" Lock… ", -1)
          ]))], 512), [
            [_vShow, !_ctx.lock]
          ]),
          _withDirectives(_createElementVNode("a", {
            class: "dropdown-item",
            href: "#",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.unlock && _ctx.unlock(...args)))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fa fa-lock-open fa-fw" }, null, -1),
            _createTextVNode(" Unlock ", -1)
          ]))], 512), [
            [_vShow, _ctx.lock]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("a", {
            class: "dropdown-item",
            href: "#",
            "data-target": "#project-remove-modal",
            "data-toggle": "modal"
          }, [
            _createElementVNode("i", { class: "fa fa-trash fa-fw" }),
            _createTextVNode(" Delete… ")
          ], -1)),
          _createElementVNode("a", {
            class: "dropdown-item",
            href: "#",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleProjectHistory && _ctx.toggleProjectHistory(...args)))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fa fa-clock fa-fw" }, null, -1),
            _createTextVNode(" Version History ", -1)
          ]))])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestVersions.slice(0, 3), (v) => {
            return (_openBlock(), _createBlock(_component_version_item, _mergeProps({
              key: v.number
            }, { ref_for: true }, {'data-version': v.number}, {
              version: v,
              project: _ctx.project,
              glasspane: _ctx.toggleGlasspane
            }), null, 16, ["version", "project", "glasspane"]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass({ 'd-none': !_ctx.showFullHistoryButton() })
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "my-2" }, null, -1)),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary btn-block btn-show-history",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showFullHistory && _ctx.showFullHistory(...args)))
          }, "Full History")
        ], 2)
      ])
    ])
  ], 8, _hoisted_1))
}